import Button from "@mostrans/web-components/components/base/Button";
import React from 'react';
import { useGetMasterTestimoniWithFilter } from "../../../../GQL/Testimonial/useGetMasterTestimoniWithFilter";
import FilterInputSearch from "../../../../components/Filter/FilterInputSearch";
import FilterStartEndDate from "../../../../components/Filter/FilterStartEndDate";
import { FlexColumn, FlexRow } from '../../../../components/Layout/Flex';
import { useGlobalLoading } from "../../../../shared/hooks/useGlobalLoading";

function HeaderFilterTestimonial() {
    const [loading, , wrapWithLoading] = useGlobalLoading();
    const { refetch } = useGetMasterTestimoniWithFilter()
    return (
        <React.Fragment>
            <FlexColumn
                flexDirection="column"
                p="1rem"
                justifyContent="stretch"
                gap="1rem"
                borderBottom="1px solid var(--color-outlineSoft)"
            >
                <FlexRow gap="1rem">
                    <div className="d-flex flex-grow-1 w-100">
                        <FilterInputSearch resetOnMount placeholder="Search Testimonial Content" containerProps={{ className: "w-100" }} />
                    </div>
                    <div>
                        <Button
                            onClick={() => loading || wrapWithLoading(() => refetch())}
                            variant="contained"
                            color="primary"
                        >
                            Refresh
                        </Button>
                    </div>
                </FlexRow>
                <FlexRow justifyContent="flex-end">
                    <b style={{ fontSize: "14px" }}>Created Date</b>
                    <FilterStartEndDate />
                </FlexRow>
            </FlexColumn>
        </React.Fragment>
    )
}

export default HeaderFilterTestimonial